import { Component, Input } from '@angular/core';

import { ChangeType, TerminalProcedure } from '../models/terminal-procedure.model';


@Component({
  selector: 'app-procedure',
  templateUrl: './procedure.component.html',
  styleUrls: ['./procedure.component.scss']
})
export class ProcedureComponent {
  @Input() procedure: TerminalProcedure;

  ChangeType = ChangeType;

  private _selected = false;

  get selected(): boolean {
    return this._selected;
  }

  @Input() set selected(value: boolean) {
    if (this.procedure.changeType !== ChangeType.Deleted) {
      this._selected = value;
    }
  }

  get active(): boolean {
    return this.procedure.changeType !== ChangeType.Deleted;
  }

  get type(): string {
    return TerminalProcedure.formatProcedureType(this.procedure.type);
  }

  get changed(): boolean {
    return this.procedure.changeType !== null;
  }

  get changeType(): string {
    return TerminalProcedure.formatChangeType(this.procedure.changeType);
  }

  get changeTypeTooltip(): string {
    switch (this.procedure.changeType) {
      case ChangeType.Added:
        return 'This procedure was added within the last data cycle.';
      case ChangeType.Changed:
        return 'This procedure has been changed within the last data cycle.';
      case ChangeType.Deleted:
        return 'This procedure was recently removed and should no longer be used.';
      default:
        return null;
    }
  }
}
